<template>
      <div class="cardPaymentConfigEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'cardPaymentConfig', params: {} }">
          Card Payment Config
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'cardPaymentConfigEdit', params:{id: id} }">
            Edit Card Payment Config
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Card Payment Config</v-card-title>
          <v-card-text>
            <cardPaymentConfig-form :id="id"></cardPaymentConfig-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import CardPaymentConfigForm from './CardPaymentConfigForm.vue';

    export default {
      name: 'cardPaymentConfig',
      data () {
        return {
          id: null
        }
      },
      components: {
        CardPaymentConfigForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    